import { PlayerEvent, type PlayerInterface, type VolumeChangedEvent } from '@foundation-player/loader';
import { readonly, writable, type Readable, type Writable } from 'svelte/store';
import type { PlayerStoreModule } from './player-store-types';

export class VolumePlayerStore implements PlayerStoreModule<'volume' | 'muted'> {
  readonly #muted: Writable<boolean> = writable(false);
  readonly muted: Readable<boolean> = readonly(this.#muted);

  readonly #volume: Writable<number> = writable(1);
  readonly volume: Readable<number> = readonly(this.#volume);

  initializeStateFromPlayer(player: PlayerInterface) {
    player.addEventListener(PlayerEvent.Ready, () => {
      this.#muted.set(player.isMuted());
      this.#volume.set(player.getVolume());
    });
    player.addEventListener(PlayerEvent.Muted, () => this.#muted.set(true));
    player.addEventListener(PlayerEvent.Unmuted, () => this.#muted.set(false));
    player.addEventListener(PlayerEvent.VolumeChanged, (event: VolumeChangedEvent) =>
      this.#volume.set(event.currentVolume),
    );

    this.#muted.set(player.isMuted());
    this.#volume.set(player.getVolume());
  }
}
